export const gaTrackPageView = (page) => {
  if (window.civiqs.config.REACT_APP_ENVIRONMENT === 'development') return;
  window.ga('set', 'page', `/${page}`);
  window.ga('send', 'pageview');
}
